import validate from "/usr/src/app/content/n3-spas-1edd674d-edbc-4557-ad56-1fd601113f7f/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-1edd674d-edbc-4557-ad56-1fd601113f7f/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}